<div class="lg:tw-mx-[10px]">
  <div class="tw-mx-[10px] lg:tw-mx-0">
    <div class="tw-group tw-mx-[6px] tw-my-3 tw-flex tw-items-center tw-gap-3 lg:tw-mx-0 lg:tw-my-4" [ngClass]="{ 'tw-hidden': isLeadsMode }">
      @if (!hideTitle) {
        <h2
          class="tw-flex-none tw-text-[24px] group-focus-within:tw-hidden sm:tw-max-w-none md:tw-block md:group-focus-within:tw-block lg:tw-text-[28px]"
          [ngClass]="{ 'tw-hidden md:tw-block': !!searchTerm }">
          {{ title }}
        </h2>
      }
      @if (linkRoute) {
        <a
          [routerLink]="[linkRoute]"
          class="tw-hidden tw-text-base tw-font-bold tw-text-brand-maroon tw-underline group-focus-within:tw-hidden sm:tw-block md:tw-block md:group-focus-within:tw-block"
          >{{ linkName }}</a
        >
      }
      <div class="tw-ml-auto tw-flex tw-flex-1 tw-items-center tw-justify-end tw-gap-2 md:tw-flex-none">
        <div
          data-testid="search-wrapper"
          class="md:tw-max-w-auto tw-min-w-0 tw-transition-all tw-duration-200 tw-ease-out md:tw-w-auto md:tw-flex-none md:group-focus-within:tw-w-auto md:group-focus-within:tw-flex-none"
          [class.tw-invisible]="!isConnected"
          [ngClass]="!!searchTerm ? 'tw-w-auto tw-flex-1' : 'tw-w-12 tw-flex-none group-focus-within:tw-w-auto group-focus-within:tw-flex-1'">
          <ate-text-input-control
            class="tw-w-full group-focus-within:!tw-p-[12px_16px_12px_52px] md:!tw-p-[12px_16px_12px_52px] [&>ate-icon]:tw-left-[11px] [&>ate-icon]:md:tw-left-[16px]"
            size="small"
            icon="search-v2"
            [state]="!!searchTerm ? 'focused' : 'normal'"
            [ngClass]="{ '!tw-p-[12px_16px_12px_52px]': !!searchTerm, '!tw-p-[23px]': !searchTerm }"
            (onValueChanges)="onValueChanges($event)"
            placeholder="Search emails"
            [value]="searchTerm"
            model-key="search">
          </ate-text-input-control>
        </div>
        <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-2">
          @if (isConnected && !isMasquerading && !hideComposeButton) {
            <ate-button-control class="tw-w-fit tw-min-w-[48px] tw-p-3 md:tw-flex md:tw-gap-2" [routerLink]="['../compose']" color="cta">
              <ate-icon class="tw-h-4 tw-w-4" name="edit-v3"></ate-icon>
              <span class="tw-hidden md:tw-block">Compose</span>
            </ate-button-control>
          }
        </div>
      </div>
    </div>

    <div class="filters tw-mb-4 tw-mt-3 tw-flex tw-flex-auto tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-3" *ngIf="filters">
      <ate-ui-filter-bar
        [filters]="filters"
        [routerLinkActiveOptions]="{ exact: false }"
        [ngClass]="{ 'tw-hidden md:tw-block': filterSearchFocused || !!searchTerm }">
      </ate-ui-filter-bar>
      @if (isLeadsMode) {
        <div
          class="tw-flex tw-shrink-0 tw-items-center tw-gap-2 tw-transition-all tw-duration-200 tw-ease-out md:tw-ml-auto"
          [class.tw-invisible]="!isConnected"
          [ngClass]="{ 'max-md:tw-flex-1': filterSearchFocused || !!searchTerm }">
          <div
            class="tw-min-w-0 tw-transition-all tw-duration-200 tw-ease-out md:tw-w-auto md:tw-flex-none"
            [class.tw-flex-1]="filterSearchFocused || !!searchTerm"
            [class.tw-w-full]="filterSearchFocused || !!searchTerm"
            [class.tw-flex-none]="!filterSearchFocused && !searchTerm"
            (focusin)="filterSearchFocused = true"
            (focusout)="filterSearchFocused = false">
            <ate-text-input-control
              class="!tw-h-[41px] tw-w-full md:!tw-h-auto md:!tw-p-[12px_16px_12px_52px] [&>ate-icon]:tw-left-[11px] [&>ate-icon]:md:tw-left-[16px]"
              size="small"
              icon="search-v2"
              [state]="filterSearchFocused || !!searchTerm ? 'focused' : 'normal'"
              [ngClass]="{
                'max-md:!tw-p-[0_16px_0_52px]': filterSearchFocused || !!searchTerm,
                '!tw-max-w-[41px] !tw-p-[16px_23px] md:!tw-max-w-none': !filterSearchFocused && !searchTerm
              }"
              (click)="filterSearchFocused = true"
              (onValueChanges)="onValueChanges($event)"
              placeholder="Search emails"
              [value]="searchTerm"
              model-key="search">
            </ate-text-input-control>
          </div>
          <ate-button-control
            class="!tw-h-[41px] !tw-w-[41px] tw-min-w-0 !tw-p-[8px] md:!tw-h-auto md:!tw-w-auto md:tw-gap-2 md:!tw-p-3"
            style="--ate-button-width: fit-content"
            color="secondary"
            (buttonClick)="refresh()">
            <ate-icon class="tw-h-4 tw-w-4" [class.tw-animate-spin]="refreshing" name="refresh-icon"></ate-icon>
            <span class="tw-hidden md:tw-inline">Refresh</span>
          </ate-button-control>
        </div>
      }
    </div>
  </div>

  @if (isConnected && isLeadsMode && !isNotLeadsMode && !isAutoRejectedMode && !isAllEmailsMode) {
    @if (automaticEmailParsing) {
      <div
        class="tw-mx-[10px] tw-mb-4 tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-border-green-200 tw-bg-green-50 tw-px-4 tw-py-3 tw-text-sm tw-text-green-800 lg:tw-mx-0">
        <ate-icon class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-green-600" name="check-circle"></ate-icon>
        <span
          >All suggestions are automatically imported to the New tab in the Pipeline.
          <a
            class="tw-inline-flex tw-items-center tw-gap-1 tw-bg-gradient-to-r tw-from-brand-gradientfrom tw-to-brand-gradientto tw-bg-clip-text tw-font-bold tw-text-transparent"
            [routerLink]="['/su', listingUuid, 'integrations', 'email']"
            target="_blank">
            Change your email settings
            <ate-icon class="tw-text-brand-maroon" name="external-link"></ate-icon>
          </a>
          to switch this off and manually import.
          @if (suggestedLeads.length) {
            <ate-button-control
              *featureToggle="'IMPORT_ALL_LEADS_BUTTON'"
              size="xsmall"
              class="tw-ml-auto tw-mt-2 tw-flex tw-w-fit tw-gap-2"
              (buttonClick)="importAllLeads()"
              [state]="importingAllLeads || importAllLeadsCooldown ? 'disabled' : ''"
              color="secondary">
              <span class="">{{ importingAllLeads || importAllLeadsCooldown ? 'Importing Leads...' : 'Import All Leads' }}</span>
            </ate-button-control>
          }
        </span>
      </div>
    } @else {
      <div
        id="automatic-email-parsing-banner"
        [class.tw-hidden]="infoBannerDismissed"
        class="tw-mx-[10px] tw-mb-4 tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-border-yellow-200 tw-bg-yellow-50 tw-px-4 tw-py-3 tw-text-sm tw-text-yellow-800 lg:tw-mx-0">
        <ate-icon class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-yellow-600" name="info-v2"></ate-icon>
        <span class="tw-flex-1"
          >Manually import your leads as they appear below.
          <a
            class="tw-inline-flex tw-items-center tw-gap-1 tw-bg-gradient-to-r tw-from-brand-gradientfrom tw-to-brand-gradientto tw-bg-clip-text tw-font-bold tw-text-transparent"
            [class.tw-pointer-events-none]="isBannerClickDisabled"
            [class.tw-opacity-50]="isBannerClickDisabled"
            (click)="onBannerClick()">
            Change your email settings
            <ate-icon class="tw-text-brand-maroon" name="external-link"></ate-icon>
          </a>
          to automatically import email enquiries.
        </span>
        <button
          (click)="dismissInfoBanner()"
          class="tw-ml-auto tw-shrink-0 tw-border-none tw-bg-transparent tw-p-0 tw-text-slate-800 hover:tw-text-slate-600">
          <ate-icon class="tw-size-5" name="close-v2"></ate-icon>
        </button>
      </div>
    }
  }

  @if (isConnected && isAllEmailsMode) {
    <div
      class="tw-mx-[10px] tw-mb-4 tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-border-yellow-200 tw-bg-yellow-50 tw-px-4 tw-py-3 tw-text-sm tw-text-yellow-800 lg:tw-mx-0">
      <ate-icon class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-yellow-600" name="info-v2"></ate-icon>
      <span
        >Go to
        <a
          class="tw-inline-flex tw-items-center tw-gap-1 tw-bg-gradient-to-r tw-from-brand-gradientfrom tw-to-brand-gradientto tw-bg-clip-text tw-font-bold tw-text-transparent"
          [routerLink]="[linkRoute]">
          {{ linkName }}
          <ate-icon class="tw-text-brand-maroon" name="external-link"></ate-icon>
        </a>
        to manage your emails.
      </span>
    </div>
  }

  @if (!isConnected && !loading) {
    <ate-marketplace-page-container>
      <ate-ui-utility-message imageSrc="assets/images/info-icon.png" title="Connect Gmail">
        <p>Link your Gmail account to view your inbox here.</p>
        <ate-button-control class="tw-flex tw-gap-2" [routerLink]="['/su', listingUuid, 'integrations', 'email']" color="secondary">
          <ate-icon class="tw-h-5 tw-w-5" name="settings-v3"></ate-icon>
          <span class="tw-hidden md:tw-block">Connect Gmail</span>
        </ate-button-control>
      </ate-ui-utility-message>
    </ate-marketplace-page-container>
  }

  @if (
    isConnected &&
    !loading &&
    !refreshing &&
    (!inbox || inbox.length === 0) &&
    !(isLeadsMode && !isNotLeadsMode && !isAutoRejectedMode && !isAllEmailsMode && automaticEmailParsing)
  ) {
    <ate-marketplace-page-container>
      <ate-ui-utility-message imageSrc="assets/images/mailbox-empty.png" [title]="emptyTitle">
        <p>{{ emptyMessage }}</p>
        <ate-button-control class="tw-flex tw-gap-2" (buttonClick)="refresh()" color="secondary">
          <ate-icon class="tw-h-4 tw-w-4" [class.tw-animate-spin]="refreshing" name="refresh-icon"></ate-icon>
          <span class="tw-hidden md:tw-block">Refresh</span>
        </ate-button-control>
      </ate-ui-utility-message>
    </ate-marketplace-page-container>
  }

  @if (loading) {
    <div
      class="tw-grid tw-overflow-hidden tw-border tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-300 tw-bg-white tw-bg-white md:tw-rounded-lg md:tw-border-l md:tw-border-r"
      aria-busy="true">
      @for (r of skeletonRows; track $index) {
        <div
          class="tw-flex tw-items-center tw-gap-4 tw-overflow-hidden tw-border-0 tw-border-b tw-border-solid tw-border-slate-300 tw-border-opacity-70 tw-px-4 tw-py-2 last:tw-border-b-0">
          <div class="tw-w-32 tw-flex-shrink-0">
            <div class="tw-h-5 tw-w-24 tw-animate-pulse tw-rounded tw-bg-slate-200"></div>
          </div>
          <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2">
            <div class="tw-h-5 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-slate-200"></div>
            <div class="tw-h-5 tw-w-full tw-animate-pulse tw-rounded tw-bg-slate-100"></div>
          </div>
          <div class="tw-w-16 tw-text-right">
            <div class="tw-ml-auto tw-h-5 tw-w-10 tw-animate-pulse tw-rounded tw-bg-slate-200"></div>
          </div>
        </div>
      }
    </div>
  }

  @if (!loading && inbox?.length) {
    <div
      class="tw-grid tw-overflow-hidden tw-border tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-300 tw-bg-white tw-bg-white md:tw-rounded-lg md:tw-border-l md:tw-border-r">
      @for (message of inbox; track message.id) {
        <div
          data-testid="message-row"
          (click)="navigateToEmail(message.id, $event)"
          [ngClass]="{ 'tw-bg-white': getIsUnread(message), '!tw-border-l-green-600': hasLinkedEnquiry(message) }"
          class="tw-transition-bg tw-group tw-cursor-pointer tw-overflow-hidden tw-border-0 tw-border-b tw-border-l-[3px] tw-border-solid tw-border-slate-300 tw-border-l-transparent tw-border-opacity-70 tw-bg-slate-50 tw-px-4 tw-py-2 last:tw-border-b-0 hover:tw-bg-slate-50 md:tw-py-1">
          <div class="tw-w-full tw-space-y-1 md:tw-hidden">
            <div class="tw-flex tw-items-baseline tw-justify-between tw-gap-2">
              <div [ngClass]="getIsUnread(message) ? 'tw-font-bold' : 'tw-font-normal'" class="tw-truncate md:tw-py-1">
                {{ getDisplayPerson(message) }}
              </div>
              <span class="tw-shrink-0 tw-text-sm">{{ getDisplayDate(message) }}</span>
            </div>
            <div [ngClass]="getIsUnread(message) ? 'tw-font-bold' : 'tw-font-normal'" class="tw-truncate">
              {{ message.subject || 'No Subject' }}
            </div>
            <div class="tw-text-muted-foreground tw-truncate">
              {{ getDisplaySnippet(message) }}
            </div>
            <!-- actions: always visible at the bottom of the tile -->
            <div class="tw-flex tw-items-center tw-gap-1 tw-pt-1">
              @if (hasLinkedEnquiry(message)) {
                <div
                  data-testid="imported-badge"
                  class="tw-box-border tw-flex tw-h-6 tw-items-center tw-gap-1 tw-rounded-2xl tw-border tw-border-solid tw-border-green-200 tw-bg-green-50 tw-p-[0_8px_0_6px] tw-text-xs tw-font-bold tw-text-green-700">
                  <ate-icon name="folder-tick" class="tw-size-3"></ate-icon>
                  Imported
                </div>
                <ate-button-control
                  class="tw-flex tw-h-auto tw-w-fit tw-min-w-0 tw-gap-2 tw-px-2 tw-py-1 tw-text-xs"
                  color="secondary"
                  (click)="navigateToLinkedEnquiry(message, $event)">
                  <ate-icon class="tw-size-3" name="ate-eye"></ate-icon>
                  View Enquiry
                </ate-button-control>
              } @else if (isAutoNotALead(message)) {
                <ng-container *ngTemplateOutlet="importEnquiryTpl; context: { $implicit: message }"></ng-container>
              } @else if (canImportAsLead(message)) {
                <ng-container *ngTemplateOutlet="importEnquiryTpl; context: { $implicit: message }"></ng-container>
                <div (click)="openNotLeadDialog(message, $event)">
                  <ate-button-control class="tw-flex tw-h-auto tw-w-fit tw-min-w-0 tw-gap-1 tw-px-2 tw-py-1 tw-text-xs" color="secondary">
                    <ate-icon class="tw-size-3" name="close-v3"></ate-icon>
                    Not a lead
                  </ate-button-control>
                </div>
              }
            </div>
          </div>

          <div class="tw-hidden tw-items-center tw-gap-4 md:tw-flex">
            <div [ngClass]="getIsUnread(message) ? 'tw-font-bold' : 'tw-font-normal'" class="tw-w-32 tw-flex-shrink-0 tw-truncate tw-py-1">
              {{ getDisplayPerson(message) }}
            </div>
            <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2">
              <span [ngClass]="getIsUnread(message) ? 'tw-font-bold' : 'tw-font-normal'" class="tw-truncate">{{
                message.subject || 'No Subject'
              }}</span>
              <span *ngIf="getDisplaySnippet(message)" class="tw-text-muted-foreground">-</span>
              <span class="tw-text-muted-foreground tw-truncate">{{ getDisplaySnippet(message) }}</span>
            </div>
            <!-- right slot: actions on hover, date by default -->
            <div class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2">
              @if (hasLinkedEnquiry(message)) {
                <div
                  data-testid="imported-badge"
                  class="tw-box-border tw-flex tw-h-6 tw-items-center tw-gap-1 tw-rounded-2xl tw-border tw-border-solid tw-border-green-200 tw-bg-green-50 tw-p-[0_8px_0_6px] tw-text-xs tw-font-bold tw-text-green-700">
                  <ate-icon name="folder-tick" class="tw-size-3"></ate-icon>
                  Imported
                </div>
              }
              <!-- actions: hidden by default, visible on row hover or when dialog is open -->
              <div class="tw-hidden tw-items-center tw-gap-2 group-hover:tw-flex" [ngClass]="{ '!tw-flex': notLeadDialogMessage?.id === message.id }">
                @if (hasLinkedEnquiry(message)) {
                  <ate-button-control
                    class="tw-flex tw-h-auto tw-w-fit tw-min-w-0 tw-gap-2 tw-px-2 tw-py-1 tw-text-xs"
                    color="secondary"
                    size="xsmall"
                    (click)="navigateToLinkedEnquiry(message, $event)">
                    <ate-icon class="tw-size-3" name="ate-eye"></ate-icon>
                    View Enquiry
                  </ate-button-control>
                } @else if (isAutoNotALead(message)) {
                  <ng-container *ngTemplateOutlet="importEnquiryTpl; context: { $implicit: message }"></ng-container>
                } @else if (canImportAsLead(message)) {
                  <ng-container *ngTemplateOutlet="importEnquiryTpl; context: { $implicit: message }"></ng-container>
                  <div (click)="openNotLeadDialog(message, $event)">
                    <ate-button-control
                      class="tw-flex tw-h-auto tw-w-fit tw-min-w-0 tw-gap-1 tw-px-2 tw-py-1 tw-text-xs"
                      color="secondary"
                      size="xsmall">
                      <ate-icon class="tw-size-3" name="close-v3"></ate-icon>
                      Not a lead
                    </ate-button-control>
                  </div>
                }
              </div>
              <!-- date: visible by default, hidden on row hover or when dialog is open -->
              <div
                class="tw-w-16 tw-text-right tw-text-sm group-hover:tw-hidden"
                [ngClass]="{ '!tw-hidden': notLeadDialogMessage?.id === message.id }">
                {{ getDisplayDate(message) }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <ate-pagination
      class="tw-mt-[20px] tw-px-[30px]"
      (onPageChange)="!loading && onPageChange($event)"
      [current]="pagination?.page"
      [pages]="pagination?.pageCount"
      [extremities]="false">
    </ate-pagination>
  }
</div>

@if (notLeadDialogMessage) {
  <email-not-lead-dialog [fromEmail]="notLeadDialogMessage.from?.email" (action)="onNotLeadAction($event)" (closed)="notLeadDialogMessage = null">
  </email-not-lead-dialog>
}

<ng-template #importEnquiryTpl let-message>
  <ate-button-control
    class="tw-flex tw-h-auto tw-w-fit tw-min-w-0 tw-gap-2 tw-px-2 tw-py-1 tw-text-xs"
    color="secondary"
    [disabled]="importingEmailId === message.id"
    (click)="importEnquiry(message, $event)">
    @if (importingEmailId === message.id) {
      <ate-icon class="tw-h-3 tw-w-3 tw-animate-spin" name="refresh-icon"></ate-icon>
    } @else {
      <ate-icon class="tw-size-3 tw-text-violet-600" name="ate-chat-gpt"></ate-icon>
    }
    Import Lead
  </ate-button-control>
</ng-template>
